import { createContext, useContext } from 'react'
import type { BillingContextValue } from '@/types'

export const BillingContext = createContext<BillingContextValue | undefined>(
  undefined,
)

export const useBilling: () => BillingContextValue = () => {
  const context = useContext(BillingContext)

  if (!context)
    throw new Error('useBilling must be used within BillingProvider')

  return context
}
